import React from "react";
import { Heart, ExternalLink } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import Candle from "./Candle";

const GOFUNDME_URL =
  "https://www.gofundme.com/f/standing-with-lupe-leah-sarah-niobe-and-zanya?cp_src=d";

const MemorialBanner = () => {
  const { t } = useLang();

  return (
    <section className="relative bg-black text-white overflow-hidden">
      <div className="h-1 w-full bg-gradient-to-r from-[#800000] via-white/20 to-[#14532d]" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-20 text-center">
        <p className="text-[#b85a6f] uppercase tracking-[0.35em] text-xs md:text-sm font-semibold mb-3">
          {t("memorial.eyebrow")}
        </p>
        <h2 className="flex items-center justify-center gap-4 md:gap-6 text-3xl md:text-5xl font-serif font-bold tracking-wide">
          <Candle className="shrink-0" />
          <span>Daniel Azpilcueta</span>
          <Candle className="shrink-0" />
        </h2>

        <div className="flex items-center justify-center gap-2 mt-5 mb-8">
          <div className="h-px w-16 bg-white/40" />
          <div className="w-1.5 h-1.5 rounded-full bg-[#b85a6f]" />
          <div className="h-px w-16 bg-white/40" />
        </div>

        <p className="text-white/85 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-8">
          {t("memorial.support_message")}
        </p>

        <a
          href={GOFUNDME_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 bg-[#800000] hover:bg-[#5a0000] text-white px-8 py-4 rounded-md font-bold text-base md:text-lg shadow-xl hover:shadow-2xl transition-all"
        >
          <Heart size={20} className="fill-white/20 group-hover:fill-white transition-colors" />
          {t("memorial.donate_cta")}
          <ExternalLink size={16} className="opacity-70 group-hover:translate-x-0.5 group-hover:opacity-100 transition-all" />
        </a>

        <p className="mt-4 text-white/50 text-xs uppercase tracking-wider">
          {t("memorial.powered_by")}
        </p>
      </div>

      <div className="h-1 w-full bg-gradient-to-r from-[#14532d] via-white/20 to-[#800000]" />
    </section>
  );
};

export default MemorialBanner;
